// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-folders__show-managed-toggle[data-v-757f890e]{cursor:pointer;color:#9c9c9c}@media (min-width: 992px){.media-folders__items-container[data-v-757f890e]{padding-left:0}}.media-folders__container[data-v-757f890e]{background-color:#E2E2E2;padding:10px;margin-bottom:40px;width:100%}.media-folders__container__wrap[data-v-757f890e]{min-height:100%;margin-bottom:-50px}\n", ""]);
// Exports
module.exports = exports;
